import React, { useState } from 'react';
import Button from './ui/Button';
import Icon from './AppIcon';
import TouchpointImageUploader from './touchpoint-media/TouchpointImageUploader';

/**
 * Optional onboarding step: add a friendly first-touch intro photo (MMS).
 */
export default function FirstTouchPhotoOnboarding({ onComplete }) {
  const [imageUrl, setImageUrl] = useState(null);

  return (
    <div className="max-w-md mx-auto text-center p-6">
      <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
        <Icon name="Camera" size={32} className="text-primary" />
      </div>

      <h2 className="text-2xl font-bold text-foreground mb-2">Add a first-touch photo</h2>
      <p className="text-muted-foreground mb-2">
        Optional — but recommended. Past clients who haven&apos;t gotten a text yet get a short intro
        (instead of that month&apos;s tip) with your photo if you add one.
      </p>
      <p className="text-sm text-foreground mb-6">
        Best: a casual selfie — smiling and waving, or a thumbs-up.
      </p>

      <div className="text-left mb-6">
        <TouchpointImageUploader
          imageUrl={imageUrl}
          purpose="first-touch"
          alignHint="a friendly hello"
          title="Your first-touch photo"
          description="Take or upload a selfie: smile + wave or thumbs-up works great. We'll compress it automatically for MMS."
          showCameraOption
          onSaved={setImageUrl}
        />
      </div>

      <div className="space-y-3">
        <Button onClick={() => onComplete?.()} className="w-full">
          {imageUrl ? 'Continue' : 'Skip for now'}
        </Button>
        {imageUrl ? (
          <p className="text-xs text-muted-foreground">Nice — this photo will go with your intro.</p>
        ) : (
          <p className="text-xs text-muted-foreground">You can add this later on Touchpoints.</p>
        )}
      </div>
    </div>
  );
}
